import React, { Component } from 'react'

class AlertBox extends Component {
  constructor(props, context) {
    super(props, context)
  }

  renderAlertBox = () => {
    const { alertBox } = this.props
    return (
      alertBox.status &&
      alertBox.msg !== '' && (
        <div
          className="ppvx_modal-backdrop overlay--box__container"
          id="alertBox"
          role="dialog"
          aria-labelledby="lightbox2-title"
          aria-modal="true"
          aria-hidden="false"
          data-ppvx_modal-background-close="true"
        >
          <div className="overlay--box__popup">
            {this.renderAlertBoxIcon(alertBox)}
            {this.renderAlertBoxMessage(alertBox)}
            {alertBox?.showSpinner && this.renderSpinner()}
            {this.renderAlertBoxAction(alertBox)}
          </div>
        </div>
      )
    )
  }

  getOverlayIconType = (type, renderFor) => {
    if (type === 'warning') {
      return renderFor === 'overlay'
        ? 'overlay__warning-icon'
        : 'ppvx_icon-warning-alt'
    }
    if (type === 'info') {
      return renderFor === 'overlay'
        ? 'overlay__info-icon'
        : 'ppvx_icon-info-alt'
    }
    if (type === 'success') {
      return renderFor === 'overlay'
        ? 'overlay__success-icon'
        : 'ppvx_icon-check-circle-alt'
    }
    return renderFor === 'overlay'
      ? 'overlay__alert-icon'
      : 'ppvx_icon-critical-alt'
  }

  renderAlertBoxIcon = (alertBox) => {
    return (
      <div
        className={`overlay__icon ${this.getOverlayIconType(
          alertBox?.type,
          'overlay',
        )}`}
      >
        <span
          className={`ppvx_icon ppvx_icon--size_lg ${this.getOverlayIconType(
            alertBox?.type,
            'icon',
          )}`}
        />
      </div>
    )
  }

  renderAlertBoxMessage = (alertBox) => {
    return (
      <div className="overlay--box__message ppvx_text--lg">
        {alertBox.msg.map((msg, index) => {
          return (
            <div className="overlay__text" key={index}>
              {msg}
            </div>
          )
        })}
      </div>
    )
  }

  renderSpinner = () => {
    return (
      <div style={{ position: 'relative' }}>
        <div className="spinnerInProgress" style={{ top: '0px' }}>
          <p className="ppvx_loading-spinner" role="alert">
            <span className="ppvx_loading-spinner__screenreader" />
          </p>
        </div>
      </div>
    )
  }

  renderAlertBoxAction = (alertBox) => {
    return (
      <div className="overlay--box__action-container">
        {alertBox.action.map((item) => {
          return (
            <div key={item}>
              <button
                id={item}
                className={`overlay--box__Action-button ppvx_btn ppvx_btn--size_md ${
                  item === 'cancel' ? 'ppvx_btn--secondary' : ''
                }`}
                onClick={() =>
                  this.props.checkAlertBoxAction(alertBox.for, item)
                }
              >
                {this.props.renderLocalizedAction(item)}
              </button>
            </div>
          )
        })}
      </div>
    )
  }

  render() {
    return <div>{this.renderAlertBox()}</div>
  }
}

export default AlertBox
